export const curatedBlogDetails = {
  "default-1": {
    id: "default-1",
    title: "5 Daily Habits to Eliminate Hesitation and Speak Fluent English",
    category: "Speaking Tips",
    author: "Fluent Fable Mentorship Team",
    date: "October 10, 2026",
    readingTime: "5 min read",
    coverImage: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80",
    sections: [
      {
        heading: "1. The Psychology of Speaking Hesitation",
        body: "Most English learners believe their pause or hesitation is caused by a lack of vocabulary. In reality, neuroscience proves that over 80% of hesitation comes from the fear of making a grammatical mistake in front of others. When you translate every sentence in your head from your native tongue into English before speaking, your brain experiences cognitive lag.",
      },
      {
        heading: "2. The 2-Minute 'Shadowing' Technique",
        body: "Shadowing is one of the most effective linguistic techniques used by simultaneous interpreters. Listen to a short 30-second audio clip from a podcast or news broadcast and speak along with the speaker with a half-second delay. This trains your tongue, teeth, and vocal cords to match native intonation and rhythm without mental filtering.",
      },
      {
        heading: "3. Replace 'Um' and 'Uh' with Strategic Filler Phrases",
        body: "Native speakers hesitate too! However, instead of awkward silence or vocalized pauses like 'umm...', they use natural connective phrases such as:\n• 'That is an intriguing question...'\n• 'From my perspective...'\n• 'What I mean to emphasize is...'\nThese give your mind 2-3 seconds to formulate the core thought without breaking the conversational momentum.",
      },
      {
        heading: "4. Practice Thinking in English Daily",
        body: "Designate 10 minutes every morning—while making coffee or commuting—where you describe your immediate surroundings exclusively in English. 'I need to grab my keys. The weather seems chilly today.' By removing the audience, you practice spontaneous sentence production free from performance anxiety.",
      },
      {
        heading: "5. Leverage Judgement-Free AI Practice",
        body: "Using tools like Fluent Fable's 24/7 AI tutor lets you test out ambitious phrases, ask for pronunciation adjustments, and experiment with complex sentence structures before using them in real-world professional discussions.",
      },
    ],
    takeaway: "Fluency is muscle memory built through consistent low-stakes daily practice. Don't aim for perfection; aim for effortless clarity.",
  },
  "default-2": {
    id: "default-2",
    title: "How to Build an Active Word Bank with Synonyms & Antonyms",
    category: "Vocabulary",
    author: "Fluent Fable Vocabulary Desk",
    date: "October 08, 2026",
    readingTime: "4 min read",
    coverImage: "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&w=1200&q=80",
    sections: [
      {
        heading: "1. The Trap of Passive Vocabulary",
        body: "Have you ever understood a word perfectly while reading an article, but found yourself unable to retrieve it when speaking in a fast conversation? That is the difference between passive and active vocabulary. You recognize thousands of words passively, but your brain defaults to the simplest 300 words under speaking pressure.",
      },
      {
        heading: "2. The Cognitive Power of Contrast (Antonyms)",
        body: "Human memory is associative. When you learn a word like 'Meticulous' alongside its opposite 'Hasty' or 'Careless', your brain creates dual anchor points. Recalling either word immediately activates the neural network of the other, doubling your retrieval speed.",
      },
      {
        heading: "3. Synonym Nuance: Not All Words Mean the Same",
        body: "Consider 'Huge', 'Gigantic', 'Colossal', and 'Monumental'. While all describe large size, 'Monumental' implies historical or enduring significance (e.g. 'a monumental achievement'), while 'Colossal' suggests overwhelming scale (e.g. 'a colossal blunder'). Learning contextual nuance is the hallmark of advanced fluency.",
      },
      {
        heading: "4. The 'Rule of Three' Application",
        body: "Whenever you learn a new word in Fluent Fable's Daily AI Insights, use it in three distinct sentences throughout the day:\n1. A professional workplace scenario.\n2. A casual dialogue with a friend.\n3. A reflective personal thought.",
      },
    ],
    takeaway: "An active vocabulary isn't about memorizing dictionary pages; it is about anchoring words in contrast and applying them in context immediately.",
  },
  "default-3": {
    id: "default-3",
    title: "Mastering Tricky Phrasal Verbs in Professional Workplaces",
    category: "Grammar & Career",
    author: "Fluent Fable Professional English Mentor",
    date: "October 05, 2026",
    readingTime: "6 min read",
    coverImage: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80",
    sections: [
      {
        heading: "1. Why Phrasal Verbs Sound More Natural",
        body: "Textbooks teach Latin-derived formal verbs like 'postpone', 'investigate', and 'tolerate'. However, in everyday business discussions across the US, UK, and multinational corporations, speakers use 'put off', 'look into', and 'put up with'. Using phrasal verbs makes your cadence sound effortless and approachable.",
      },
      {
        heading: "2. Essential Phrasal Verbs for Meetings",
        body: "• 'Bring up' — To mention a topic for discussion ('Let me bring up the Q3 budget.').\n• 'Follow up' — To check the progress of an action item ('I will follow up with the design team.').\n• 'Wrap up' — To conclude a session ('Let us wrap up today's meeting on schedule.').\n• 'Zero in on' — To focus intensely on a specific problem.",
      },
      {
        heading: "3. Separable vs. Inseparable Phrasal Verbs",
        body: "Pay attention to whether pronouns can sit between the verb and preposition. For instance, 'Turn it on' is correct (separable), while 'Look into it' cannot be split into 'Look it into' (inseparable). Practicing with interactive quizzes builds intuition so you never have to guess the grammatical rule.",
      },
    ],
    takeaway: "Mastering 20 core phrasal verbs will instantly upgrade your spoken English from textbook rigid to fluid and professional.",
  },
};
